import { render, staticRenderFns } from "./BatchRunCard.vue?vue&type=template&id=44364a56&scoped=true"
import script from "./BatchRunCard.vue?vue&type=script&lang=js"
export * from "./BatchRunCard.vue?vue&type=script&lang=js"
import style0 from "./BatchRunCard.vue?vue&type=style&index=0&id=44364a56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44364a56",
  null
  
)

export default component.exports